import FoulingPolynomialsData from "./data";

export default function mapFoulingPolynomialsData(json) {
    return new FoulingPolynomialsData(
        json.date,
        json.preds,
        json.preds_linear,
        json.Time,
        json.vesselid,
        json.method,
        json.period
    );
}

